
















import Vue from 'vue';
import Component from 'vue-class-component';
import IntersectionDirective from '@/common/vue/intersection-directive';
import { JumpToEventBusEvents, JumpToEventBus } from '@/webcomponents/header/components/JumpToEventBus';

const WordFade = () => import('../../common/vue/WordFade.vue');

const SocialMediaBoxProps = Vue.extend({
  props: {
    headline: String,
    headlineTag: {
      type: String,
      default: 'h2',
      validator: (val) => ['h2', 'h3', 'h4', 'h5', 'h6'].includes(val),
    },
    color: {
      type: String,
      default: 'white',
      validator: (val) => ['white', 'black'].includes(val),
    },
    editMode: Boolean,
  },
});

@Component({
  components: {
    WordFade,
  },
  directives: {
    intersect: IntersectionDirective,
  },
})
export default class SocialMediaBox extends SocialMediaBoxProps {
  isIntersecting = false;
  get rootClasses () {
    return {
      'brandhub-social-media-box--color-black': this.color === 'black',
      'brandhub-social-media-box--color-white': this.color === 'white',
      'brandhub-social-media-box--edit-mode': this.editMode,
    };
  }

  handleIntersection (isIntersecting: boolean, el: HTMLElement) {
    const { top } = el.getBoundingClientRect();
    // if element is now becoming visible from bottom
    if (isIntersecting || top <= 0) {
      this.isIntersecting = true;
    } else if (!isIntersecting) {
      this.isIntersecting = false;
    }
  }

  scrollToFooter () {
    this.$el.scrollIntoView({ behavior: 'smooth' });
  }

  created () {
    JumpToEventBus.$on(JumpToEventBusEvents.JumpToFooter, this.scrollToFooter);
  }
}
